module.exports = __webpack_public_path__ + "static/media/wide.e99bfef6.jpg";